module.exports = {
  language: 'Idioma',
  selectLanguage: 'Seleccionar Idioma',
  charging: 'Cargando',
  notCharging: 'No Cargando',
  advanceSetting: 'Configuración Avanzada',
  chargingDesc: 'Iniciar carga cuando el nivel de batería esté por debajo de ',
  enabled: 'Habilitado',
  disabled: 'Deshabilitado',
  onPowerRestore: 'Al Restaurar Energía',
  powerWakeDesc: '** Use dos cargadores USB independientes para cargar la Pi y PiSugar respectivamente, y mantenga encendido el interruptor de PiSugar. Se encenderá automáticamente cuando se restaure la alimentación externa.',
  powerWakeDescFor3: 'PiSugar se encenderá automáticamente cuando se restaure la alimentación externa.',
  powerWakeOffWarning: 'Ha desactivado la función de encendido al restaurar energía, no suministre alimentación externa por separado a la Raspberry Pi.',
  powerWakeOffTitle: 'Nota',
  confirmButtonText: 'Confirmar',
  wakeUpFeature: 'Encendido Programado',
  repeat: 'Repetir',
  repeatEveryday: 'repetir todos los días.',
  repeatOn: 'repetir el',
  checkAll: 'Seleccionar Todo',
  clearAll: 'Limpiar Todo',
  wakeUpDesc: 'Encendido programado a las',
  wakeUpOffDesc: 'Encendido programado desactivado.',
  buttonFunction: 'Función de Botón Personalizada',
  singleTapLabel: 'Toque Simple',
  doubleTapLabel: 'Doble Toque',
  longTapLabel: 'Toque Largo',
  singleTap: 'toque simple',
  doubleTap: 'doble toque',
  longTap: 'toque largo',
  none: 'ninguno',
  edit: 'Editar',
  customShell: 'Shell Personalizado',
  shutdown: 'Apagar',
  shellModalTitle: {
    single: 'Shell a ejecutar para toque simple',
    double: 'Shell a ejecutar para doble toque',
    long: 'Shell a ejecutar para toque largo'
  },
  shell: 'Shell',
  shellPlaceholder: 'Ingrese el script shell aquí...',
  cancel: 'Cancelar',
  confirm: 'Confirmar',
  triggered: 'Activado',
  safeShutdown: 'Apagado Seguro',
  batteryLevel: 'Nivel de Batería',
  immediately: 'Inmediatamente',
  secondsDelay: 'segundos de retraso',
  rtcTime: 'Hora RTC',
  sysTime: 'Hora del Sistema',
  syncTime: 'Sincronizar Hora',
  weekDay: {
    Monday: 'Lunes',
    Tuesday: 'Martes',
    Wednesday: 'Miércoles',
    Thursday: 'Jueves',
    Friday: 'Viernes',
    Saturday: 'Sábado',
    Sunday: 'Domingo'
  },
  weekDayShort: {
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mié',
    Thu: 'Jue',
    Fri: 'Vie',
    Sat: 'Sáb',
    Sun: 'Dom'
  },
  batteryInputProtect: 'Protección de Entrada de Batería',
  batteryInputProtectDesc: 'El proceso de carga se detendrá cuando se alcance el 60% ~ 80% de la batería, lo que puede extender efectivamente la vida útil de la batería.',
  antiMistouch: 'Anti Toque Accidental',
  antiMistouchDesc: 'Cuando el anti-toque accidental está activado, el interruptor debe mantenerse presionado para activarse.',
  softPoweroff: 'Apagado Suave',
  softPoweroffDesc: 'Usar el botón de encendido para apagar no cortará directamente la energía, el comando de apagado será emitido por el software.',
  softPoweroffShell: 'Shell de Apagado Suave',
  softPoweroffShellDesc: 'Shell a ejecutar cuando se active el evento de apagado suave.',
  changeLoginPassword: 'Cambiar Contraseña de Inicio de Sesión',
  username: 'Nombre de Usuario',
  password: 'Contraseña',
  passwordConfirm: 'Ingrese la contraseña nuevamente',
  usernameCannotBeEmpty: 'El nombre de usuario no puede estar vacío',
  passwordCannotBeEmpty: 'La contraseña no puede estar vacía',
  passwordNotConsistent: 'Las dos contraseñas deben ser idénticas',
  usernameWithSpace: 'El nombre de usuario no puede contener espacios',
  passwordWithSpace: 'La contraseña no puede contener espacios',
  changePasswordSuccess: 'La modificación se ha completado.',
  loginDialog: 'Iniciar Sesión',
  login: 'Iniciar Sesión'
}



// WEBPACK FOOTER //
// ./src/locale/es-ES.js